var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"id":"exportData"}},[_c('QueryDayawan',{attrs:{"title":_vm.title},on:{"excel":_vm.excel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }